import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { SimpleTooltip } from '@/components/ui/simple-tooltip';
import { formatDisplayDate } from '@/utils/date-formatters/date-formatters';

import { TimeOffScheduledChange } from '../../types/time-off';

interface ScheduledChangeBadgeProps {
  scheduledChange: TimeOffScheduledChange;
}

export const ScheduledChangeBadge = ({ scheduledChange }: ScheduledChangeBadgeProps) => {
  const { t } = useTranslation('authenticated.settings');

  const tooltipContent = t('pages.timeOff.scheduled.tooltip', {
    date: formatDisplayDate(scheduledChange.effectiveStartDate),
  });

  return (
    <SimpleTooltip content={tooltipContent}>
      <Badge variant="warning" className="cursor-default gap-1">
        <AlertTriangle className="h-3 w-3" />
        {t('pages.timeOff.scheduled.badge')}
      </Badge>
    </SimpleTooltip>
  );
};
